/* eslint-disable no-console */
import { getEnvVar } from './env';

export const logUpdateRulesEvaluationResult = (
  { entityName, fieldName, index, value, logInfo },
  testDebug = false
) => {
  const debug = getEnvVar('REACT_APP_DEBUG');

  if (!debug && !testDebug) {
    return;
  }

  const { ruleId, actionId, actionType, isMapping } = logInfo;

  console.groupCollapsed(
    `%c🎬 ${actionType} | ${entityName}.${fieldName} = ${value}`,
    'font-weight: normal'
  );
  console.log(`Index: [${index}]`);
  console.log(`Action id: ${actionId}`);
  console.log(`Rule id: ${ruleId}`);
  if (isMapping) {
    console.log(`Mapping: ${isMapping}`);
  }
  console.groupEnd();
};

export const logValidationRulesEvaluationResult = (logInfo, testDebug = false) => {
  const debug = getEnvVar('REACT_APP_DEBUG');

  if (!debug && !testDebug) {
    return;
  }

  const { actionType, entityName, fieldName, index, message, actionId, ruleId } = logInfo;

  console.groupCollapsed(`%c🎬 ${actionType} | ${entityName}.${fieldName}`, 'font-weight: normal');
  console.log(`Index: [${index}]`);
  console.log(`Message: ${message}`);
  console.log(`Action id: ${actionId}`);
  console.log(`Rule id: ${ruleId}`);
  console.groupEnd();
};

export const logInteractionRulesEvaluationResult = (logInfo, testDebug = false) => {
  const debug = getEnvVar('REACT_APP_DEBUG');

  if (!debug && !testDebug) {
    return;
  }

  const { actionType, parameterType, targetTable, index, actionId, ruleId } = logInfo;

  console.groupCollapsed(`%c🎬 ${actionType} | ${targetTable}`, 'font-weight: normal');
  console.log(`Index: [${index}]`);
  console.log(`Parameter type: ${parameterType}`);
  console.log(`Action id: ${actionId}`);
  console.log(`Rule id: ${ruleId}`);
  console.groupEnd();
};

export const logRulesChainingDepth = (chainingDepth, testDebug = false) => {
  const debug = getEnvVar('REACT_APP_DEBUG');

  if (!debug && !testDebug) {
    return;
  }

  if (chainingDepth) {
    console.log(`⛓ Rules chaining: depth ${chainingDepth}`);
  } else {
    console.log('⚙️ Rules eval started');
  }
};

export const logDefaultValueEvaluationResult = (
  { entityName, fieldName, index, value, formula, id },
  testDebug = false
) => {
  const debug = getEnvVar('REACT_APP_DEBUG');

  if (!debug && !testDebug) {
    return;
  }

  console.groupCollapsed(
    `%c🛠 Default value | ${entityName}.${fieldName} = ${value}`,
    'font-weight: normal'
  );
  console.log(`Control id: ${id}`);
  console.log(`Index: [${index}]`);
  console.log(`Formula: ${formula}`);
  console.groupEnd();
};

export const logSetValueEvaluationResult = (changesToApply, testDebug = false) => {
  const debug = getEnvVar('REACT_APP_DEBUG');

  if (!debug && !testDebug) {
    return;
  }

  changesToApply.forEach(({ entityName, fieldName, index, value, formula, id }) => {
    console.groupCollapsed(
      `%c🎯 Set value | ${entityName}.${fieldName} = ${value}`,
      'font-weight: normal'
    );
    console.log(`Control id: ${id}`);
    console.log(`Index: [${index}]`);
    console.log(`Formula: ${formula}`);
    console.groupEnd();
  });
};

export const PAGE_LOAD_TIMER = 'PAGE_LOAD_TIMER';
export const HIGH_VOLUME_DATA_TIMER = 'HIGH_VOLUME_DATA_TIMER';
export const SUBMIT_TIMER = 'SUBMIT_TIMER';

const timers = {};

export const startTimer = (type) => {
  timers[type] = Date.now();
};

export const endTimer = (type) => {
  timers[type] = Date.now() - timers[type];

  return timers[type] / 1000;
};

export const getTimer = (type) => {
  return (Date.now() - timers[type]) / 1000;
};

export const logApiError = (errorMessage = '') =>
  console.log(
    '%c🚨 Some error has occurred with the following error message:\n',
    'font-weight: bold',
    `${errorMessage}`
  );

export const logUIVersion = () => {
  const uiVersion = window.envProps?.UI_VERSION;

  if (!uiVersion) {
    console.log('⚠️ UI version not found');
    return;
  }

  console.log(`🚀 Current UI version: %c${uiVersion}`, 'color: #06C; font-weight: bold;');
};
